import React from "react";

const AboutUs = () => {
  return (
    <div className="about-container">
      <h2>Welcome to HomeCraft</h2>
      <p className="about-text">
      Welcome to HomeCraft, where we bring together the art of glassmaking with creative design to offer unique antique pieces. Our goal is simple: to blend timeless elegance with modern style, providing a diverse range of glass items that suit any taste or space.

At HomeCraft, we're passionate about creating high-quality pieces that stand the test of time. Whether you're looking for a statement piece for your living room, a special gift, or something to add character to your collection, our team is here to bring your vision to life.


      </p>
      <p className="about-text">
      From delicate stained glass windows to intricate glassware, each item in our collection is carefully crafted with skill and attention to detail. We take pride in preserving the tradition of craftsmanship while adding a touch of sophistication to every piece.

Explore our collection today and discover the beauty of bespoke antiques with HomeCraft.
      </p>
      <div className="contact-details">
        <h3>Contact Details</h3>
        <ul>
          <li><strong>Address:</strong> Best Glass Compound,Labour Colony Firozabad, Uttar Pradesh, 283203</li>
          <li><strong>Phone:</strong> (+91) 7500064193</li>
          <li><strong>Email:</strong>homecraft292@gmail.com</li>
          <li><strong>Website:</strong> www.homecraft.netlify.app</li>
        </ul>
      </div>
    </div>
  );
};

export default AboutUs;
